import React from 'react';

import { StyledCard } from './styled';
import type { CardProps } from './types';

export const Card: React.FC<CardProps> = ({
  children,
  clickable = false,
  overflowHidden = false,
  center = false,
  sticky = false,
  className,
  testId,
  styleProps,
  ...props
}) => {
  return (
    <StyledCard
      $clickable={clickable}
      $overflowHidden={overflowHidden}
      $center={center}
      $sticky={sticky}
      $styleProps={styleProps}
      className={className}
      data-testid={testId}
      {...props}
    >
      {children}
    </StyledCard>
  );
};